export default __webpack_public_path__ + "static/media/Group 248.047494a3.png";